import { processTypes } from '@domain/constants';
import { Branding, ContentOptions } from '@domain/interfaces';

const detectContentType: (branding: Branding | null) => ContentOptions = (
  branding,
) => {
  if (branding && branding.objectType === processTypes.Schadegarant) {
    return 'SG';
  }
  if (branding && branding.objectType === processTypes.DealerSaas) {
    return 'dealerSaas';
  }
   if (branding && branding.objectType === processTypes.IntakePlus) {
    return 'intakePlus';
  }
  return 'notCustom';
};

export default detectContentType;
